import type { SupportedLocale } from "staticConfiguration";
import type { SelectOption } from "core/entities";
import { compareByLabel } from "core/utils/compareByLabel";
import { isSelectOption } from "core/utils/isSelectOption";
import { useMemo } from "react";
import { useAvailableLocales } from "./useAvailableLocales";
import { useLocaleFormatter } from "./useLocaleFormatter";

export function useLocaleName(locale: SupportedLocale) {
  const formatLocale = useLocaleFormatter();
  return formatLocale(locale) ?? locale;
}

export function useAvailableLocaleOptions(options?: {
  showLocaleCode?: boolean;
}) {
  const { availableLocales, data, isError, isLoading } = useAvailableLocales();
  const formatLocale = useLocaleFormatter();

  const localeOptions = useMemo<SelectOption<SupportedLocale>[]>(
    () =>
      availableLocales
        .map((loc) => {
          const name = formatLocale(loc) ?? loc;
          return {
            label: options?.showLocaleCode ? `${name} (${loc})` : name,
            value: loc,
          };
        })
        .filter(isSelectOption)
        .sort(compareByLabel),
    [availableLocales, options?.showLocaleCode, formatLocale]
  );
  return { localeOptions, data, isError, isLoading, availableLocales };
}
